import React, { useState } from 'react';
import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  useToast
} from '@chakra-ui/react';
import moment from 'moment';
import OrderApi from 'api/orders';
import Card from 'components/card/Card';

const InstallmentsTable = (props) => {
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const toast = useToast();
  const toastIdRef = React.useRef();

  const installments = props.installments;
  const category = props.category;

  const textColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

  const FetchInvoice = async (id) => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
    try {
      setInvoiceLoading(true);
      let response = await OrderApi.GetInvoice(id);
      response = response.data;
      console.log('5response = ', response);
      setInvoiceLoading(false);
      if (response.status_code === 200) {
        window.open(response?.data?.read_url, '_blank');
      } else {
        setInvoiceLoading(false);
        toastIdRef.current = toast({
          title:
            response?.message ||
            'Unable to Generate Invoice, please try again in few moments..',
          status: 'error',
          duration: 5000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
      setInvoiceLoading(false);
      toastIdRef.current = toast({
        title: 'Unable to Generate Invoice, please try again in few moments..',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      });
    }
  };

  return (
    <Flex
      height='100%'
      direction='column'>
      <Card
        mt={4}
        direction='column'
        bgColor='gray.200'
        w='100%'
        minHeight='12rem'
        maxHeight='42rem'
        px='0px'
        overflowX='scroll'>
        <Flex overflow='visible'>
          <Table
            variant='simple'
            color='gray.500'
            mb='24px'>
            <Thead>
              <Tr>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Sr.no
                  </Flex>
                </Th>
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Amount Paid
                  </Flex>
                </Th>
                {category === 'Gold' && (
                  <Th
                    pe='10px'
                    borderColor={borderColor}>
                    <Flex
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: '10px', lg: '12px' }}
                      color='gray.500'>
                      weight / rate
                    </Flex>
                  </Th>
                )}
                <Th
                  pe='10px'
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: '10px', lg: '12px' }}
                    color='gray.500'>
                    Date of Payment
                  </Flex>
                </Th>
              </Tr>
            </Thead>

            <Tbody>
              {installments?.map((obj, index) => {
                return (
                  // <Link to={{ pathname: '/permission-group', state: obj.id }}>
                  <Tr key={obj.id}>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {index + 1}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {obj.amount}
                        </Text>
                      </Flex>
                    </Td>
                    {category === 'Gold' && (
                      <Td>
                        <Flex align='center'>
                          <Text
                            me='10px'
                            color={textColor}
                            fontSize='sm'
                            fontWeight='700'>
                            {`${obj.weight_credit} gm /  ${obj.metal_price} per gm `}
                          </Text>
                        </Flex>
                      </Td>
                    )}
                    <Td>
                      <Flex align='center'>
                        <Text
                          me='10px'
                          color={textColor}
                          fontSize='sm'
                          fontWeight='700'>
                          {moment(obj.date_of_payment).format(
                            'DD MMM YY, HH:mm'
                          )}
                        </Text>
                      </Flex>
                    </Td>
                    <Td>
                      <Button
                        ml='auto'
                        isLoading={invoiceLoading}
                        variant='brand'
                        onClick={() => {
                          FetchInvoice(obj.order_id);
                        }}
                      >
                        <Text fontWeight='bold'>View Invoice</Text>
                      </Button>
                    </Td>
                  </Tr>
                  // </Link>
                );
              })}
            </Tbody>
          </Table>
        </Flex>
      </Card>
    </Flex>
  );
};

export default InstallmentsTable;
